import OmegaTracker, { IAttrs, EventTarget } from '@didi/omega-tracker';
import { Storage, Env } from 'core';

// 初始化设置appKey 及其他属性
const Omega = OmegaTracker.getTracker({
  appKey: 'omega2851ac26f4', // appkey
  uploadHost: 'omgup.didiglobal.com', // 上报地址
});

const trackEvent = (eventId: string, eventLabel?: string, attrs?: IAttrs, target?: EventTarget) => {
  try {
    if (Omega) {
      Omega.trackEvent(eventId, eventLabel, attrs, target);
    }
  } catch (err) {
    console.log('omega upload error');
  }
};

const traceApiError = (
  base: string,
  {
    path = '',
    params = '',
    status = 0,
    code = 0,
    msg = '',
    trace_id = '',
    ...others
  }: {
    path: string;
    params: string | object;
    status: number | string;
    code: number | string;
    msg: string;
    trace_id: string;
  },
) => {
  const android = /(?:Android)/.test(navigator?.userAgent) ? 'Android' : '';
  const ios = /(?:iPhone)/.test(navigator?.userAgent) || /(?:iPad)/.test(navigator?.userAgent) ? 'IOS' : '';
  trackEvent('tech_fleetapp_api_error', '', {
    base: base || path || '',
    path,
    params,
    status,
    code,
    msg,
    trace_id,
    user_id: sessionStorage?.fleet_uid || '', // 用户、系统信息收敛至接口内
    username: '',
    os_type: android || ios || 'PC', // 存在嵌入pc场景
    os_version: '',
    env: Env.APP_ENV,
    app_version: Storage.getQuery('appversion'),
    ...others,
  });
};

const traceBusinessError = (
  business: string, // 业务场景
  type: string, // 类型
  {
    params = '',
    status = 0,
    msg = '',
    ...others
  }: {
    params?: string | object;
    status?: number | string;
    msg?: string;
  },
) => {
  const android = /(?:Android)/.test(navigator?.userAgent) ? 'Android' : '';
  const ios = /(?:iPhone)/.test(navigator?.userAgent) || /(?:iPad)/.test(navigator?.userAgent) ? 'IOS' : '';

  trackEvent('tech_gasapp_business_error', '', {
    business,
    type,
    params,
    status,
    msg,
    user_id: sessionStorage?.fleet_uid || '', // 用户、系统信息收敛至接口内
    username: '',
    os_type: android || ios || 'PC', // 存在嵌入pc场景
    os_version: '',
    app_version: Storage.getQuery('appversion'),
    country: Storage.getCountry(),
    env: Env.APP_ENV,
    ...others,
  });
};

export default {
  Omega,
  trackEvent,
  traceApiError,
  traceBusinessError,
};
